import { ReactElement } from 'react'
import ProposalPercent from './ProposalPercent'
import SalesChart from './ConversionChart'

import { AnalyticsTableTef, AnalyticsTableWeb } from './AnalyticsTable'
import {
  AnalyticsCurrentTef,
  AnalyticsCurrentWeb,
} from './AnalyticsCurrentMonth'

import { useNavigate } from 'react-router-dom'

import { useAuth, useGuard } from '../../hooks/auth'

import { LOCAL_EXECUTION } from '../../utils/featureFlag'

import {
  FContainer,
  Container,
  HeaderContainer,
  HeaderTitleText,
  MainContainer,
  TitleContainer,
  MainGrid,
  LeftPanel,
  RightPanel,
  BottomPanel,
} from './style'

export function LegacyAdvanceAnalytics(): ReactElement {
  const authContext = useAuth()
  const navigate = useNavigate()
  const { authHookWithOutEvent } = authContext

  // AUTH SECTION
  if (!LOCAL_EXECUTION) {
    authHookWithOutEvent(navigate)
  }

  useGuard(['ADVANCED'])

  // ---------------------------------------------

  return (
    <FContainer>
      <Container>
        <MainContainer>
          <HeaderContainer>
            <TitleContainer>
              <HeaderTitleText>{'Dashboard Antecipação'}</HeaderTitleText>
            </TitleContainer>
          </HeaderContainer>
          <AnalyticsCurrentWeb />
          <AnalyticsCurrentTef />
          <br />
          <br />
          <MainGrid>
            <LeftPanel>
              <SalesChart label="" />
            </LeftPanel>
            <RightPanel>
              <ProposalPercent title="Propostas Taxa Zero" />
            </RightPanel>
          </MainGrid>

          <BottomPanel>
            <AnalyticsTableWeb key={'web-table'} />
          </BottomPanel>
          <BottomPanel>
            <AnalyticsTableTef key={'tef-table'} />
          </BottomPanel>
        </MainContainer>
      </Container>
    </FContainer>
  )
}
